import Icon from '../components/Icon.vue'

Icon.register({
  diagnoses: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M496 256C504.8 256 512 248.8 512 240S504.8 224 496 224 480 231.2 480 240 487.2 256 496 256zM320 176C368.5 176 408 136.5 408 88S368.5 0 320 0 232 39.5 232 88 271.5 176 320 176zM59.8 364C70 379.3 89.1 381.8 102.7 373.8 118.9 364.2 158.9 342.1 208 325.2V416H432V325.3C481.1 342.1 521.1 364.3 537.3 373.9 550.9 381.9 570 379.2 580.2 364.1L598 337.4C606.8 324.2 605.6 302.8 588 292.3 576.1 285.2 558.3 275.3 536.9 264.9 508.8 311 437.5 282.7 449.2 229.8 409.3 217.2 365.1 208 320 208 263 208 207.1 222.5 160 240.2 159.8 280.4 112.4 303.5 80.8 276.2 69.6 282.2 59.5 287.8 52.1 292.2 34.5 302.7 33.3 324 42.1 337.3L59.8 364zM368 344C381.3 344 392 354.7 392 368S381.3 392 368 392 344 381.3 344 368 354.7 344 368 344zM272 248C285.3 248 296 258.7 296 272S285.3 296 272 296 248 285.3 248 272 258.7 248 272 248zM112 256C120.8 256 128 248.8 128 240S120.8 224 112 224 96 231.2 96 240 103.2 256 112 256zM624 448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H624C632.8 512 640 504.8 640 496V464C640 455.2 632.8 448 624 448z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/diagnoses.js
// module id = 8tq6
// module chunks = 144